import { render, staticRenderFns } from "./IsolatedTagsDialog.vue?vue&type=template&id=eff78726&scoped=true"
import script from "./IsolatedTagsDialog.vue?vue&type=script&lang=js"
export * from "./IsolatedTagsDialog.vue?vue&type=script&lang=js"
import style0 from "./IsolatedTagsDialog.vue?vue&type=style&index=0&id=eff78726&prod&lang=scss"
import style1 from "./IsolatedTagsDialog.vue?vue&type=style&index=1&id=eff78726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff78726",
  null
  
)

export default component.exports